// extracted by mini-css-extract-plugin
export var aiStarIcon = "_t8-2";
export var container = "_t8-4";
export var dismissButton = "_t8-3";
export var hasPaddingBottom = "_t8-6";
export var last = "_t8-e";
export var scrollbarThumb = "_t8-c";
export var scrollbarTrack = "_t8-b";
export var selected = "_t8-9";
export var spin = "_t8-1";
export var spinning = "_t8-0";
export var suggestionItem = "_t8-d";
export var suggestionsPanel = "_t8-5";
export var tonePill = "_t8-8";
export var tonesContainer = "_t8-7";
export var unselected = "_t8-a";